import { render } from "./CountrySelect.vue?vue&type=template&id=4c5c2846"
import script from "./CountrySelect.vue?vue&type=script&lang=js"
export * from "./CountrySelect.vue?vue&type=script&lang=js"
script.render = render

export default script